import {
    FETCH_USERS_REQUESTED,
    FETCH_USERS_SUCCEED,
    FETCH_USERS_FAIL,
    FETCH_USER_REQUESTED,
    FETCH_USER_SUCCEED,
    FETCH_USER_FAIL,
    EDIT_USER_REQUESTED,
    EDIT_USER_SUCCEED,
    EDIT_USER_FAIL,
    FETCH_USER_PHOTO_REQUESTED,
    FETCH_USER_PHOTO_SUCCEED,
    FETCH_USER_PHOTO_FAIL,
    FETCH_USER_PHOTO_UPLOAD_SUCCEED,
    FETCH_USER_PHOTO_UPLOAD_FAIL,
    FETCH_USER_PHOTO_SELECT, FETCH_USER_PHOTO_SAVE_SUCCEED, FETCH_USER_PHOTO_SAVE_FAIL,
} from './actionTypes';

import produce from 'immer';
import findIndex from 'lodash/findIndex';

const initialState = {
    count: 0,
    namePrefix: '',
    users: [],
    isUsersLoading: false,
    error: null,
    photosDefaultState: true,
    user: {
        description: null,
        display_name: null,
        facebook_account: null,
        instagram_account: null,
        internal_description: null,
        is_confirmed: true,
        phone_number: null,
        recommendations: [],
        skills: [],
        vk_account: null
    },
    isUserLoading: true,
    photos: [],
};
const UserErrors = {
    fetchUsersFailed: 'Не удалось обновить список пользователей.',
    fetchUsersDetails: 'Не удалось обновить данные о пользователе.',
    editUserFailed: 'Не удалось сохранить данные пользователя.'
};

const usersReducer = produce((draft = initialState, action) => {
    switch (action.type) {
        case FETCH_USERS_REQUESTED:
            draft.error = null;
            draft.isUsersLoading = true;
            return draft;

        case FETCH_USERS_SUCCEED:
            draft.users = action.payload.users;
            draft.isUsersLoading = false;
            return draft;

        case FETCH_USERS_FAIL:
            draft.isUsersLoading = false;
            draft.error = action.error;
            draft.errorText = UserErrors.fetchUsersFailed;
            return draft;

        case FETCH_USER_REQUESTED:
            draft.isUserLoading = true;
            draft.error = null;
            return draft;

        case FETCH_USER_SUCCEED:
            draft.user = action.payload.user;
            draft.isUserLoading = false;
            draft.error = null;
            return draft;
        case FETCH_USER_FAIL:
            draft.isUserLoading = false;
            draft.error = action.error;
            draft.errorText = UserErrors.fetchUsersDetails;
            return draft;

        case EDIT_USER_REQUESTED:
            draft.isUserLoading = true;
            return draft;

        case EDIT_USER_SUCCEED:
            draft.isUserLoading = true;
            return draft;

        case EDIT_USER_FAIL:
            draft.isUserLoading = false;
            draft.error = action.error;
            draft.errorText = UserErrors.editUserFailed;
            return draft;

        case FETCH_USER_PHOTO_REQUESTED:
            draft.photos = []
            return draft;

        case FETCH_USER_PHOTO_SUCCEED:
            draft.photos = action.payload.photos;
            draft.photosDefaultState = true
            return draft;
        case FETCH_USER_PHOTO_FAIL:
            draft.error = action.error;
            return draft;

        case FETCH_USER_PHOTO_SELECT:
            // eslint-disable-next-line no-case-declarations
            const key = findIndex(draft.photos,{original_url:action.payload.photo.src})
            // eslint-disable-next-line no-case-declarations
            const selectPhoto = {...draft.photos[key], isSelected: !action.payload.photo.isSelected}
            draft.photos[key] = selectPhoto
            draft.photosDefaultState = false;
            return draft;

        case FETCH_USER_PHOTO_UPLOAD_SUCCEED:
            draft.photos = [ ...draft.photos, action.payload.photo] ;
            draft.photo = action.payload.photo;
            draft.photosDefaultState = false;
            return draft;

        case FETCH_USER_PHOTO_UPLOAD_FAIL:
            draft.error = action.error;
            return draft;

        case FETCH_USER_PHOTO_SAVE_SUCCEED:
            draft.photos = action.payload.photos;
            draft.photosDefaultState = true;
            return draft;
        case FETCH_USER_PHOTO_SAVE_FAIL:
            draft.error = action.error;
            return draft;

        default:
            return draft;
    }
});
export default usersReducer;



// WEBPACK FOOTER //
// ./src/store/users/reducer.js